export const COMPLAINT_CATEGORIES = [
  {
    value: 'assembly_defect',
    label: 'Assembly Defect',
    description: 'Physical build quality issues from the manufacturing process',
    subtypes: [
      { value: 'solder_defect',            label: 'Solder defect',               hint: 'Cold joint, bridge, insufficient solder, missing solder' },
      { value: 'component_placement_error', label: 'Component placement error',   hint: 'Wrong orientation, misaligned, off-pad' },
      { value: 'physical_damage',           label: 'Physical damage',             hint: 'Broken leads, cracked body, scratched PCB' },
      { value: 'cosmetic_defect',           label: 'Cosmetic / surface defect',   hint: 'Flux residue, marking errors, surface contamination' },
      { value: 'mechanical_failure',        label: 'Mechanical failure',          hint: 'Connector, housing, or mechanical assembly failure' },
    ]
  },
  {
    value: 'parts_compliance',
    label: 'Wrong / Missing Parts',
    description: 'BOM non-compliance — incorrect, missing or unapproved components',
    subtypes: [
      { value: 'wrong_component_fitted', label: 'Wrong component fitted',   hint: 'Different part number, wrong value, wrong package' },
      { value: 'missing_component',      label: 'Missing component',        hint: 'Component not populated, missing from build' },
      { value: 'wrong_revision_bom',     label: 'Wrong revision / BOM',    hint: 'Built to outdated BOM or incorrect revision' },
      { value: 'wrong_quantity',         label: 'Wrong quantity delivered', hint: 'Delivered more or fewer units than ordered' },
    ]
  },
  {
    value: 'functional_failure',
    label: 'Functional Failure',
    description: 'Product does not meet functional or electrical specification',
    subtypes: [
      { value: 'failed_functional_test', label: 'Failed functional test', hint: 'Unit fails ICT, FCT, or end-of-line test' },
      { value: 'out_of_spec',            label: 'Out of specification',   hint: 'Measured parameter outside defined tolerance' },
      { value: 'esd_damage',             label: 'ESD damage',             hint: 'Electrostatic discharge damage, latent or hard failure' },
      { value: 'intermittent_fault',     label: 'Intermittent fault',     hint: 'Fault that appears/disappears under certain conditions' },
    ]
  },
  {
    value: 'delivery_issue',
    label: 'Delivery Issue',
    description: 'Logistics, timing, or transport problems',
    subtypes: [
      { value: 'late_delivery',       label: 'Late delivery',          hint: 'Delivered after agreed deadline' },
      { value: 'damaged_in_transit',  label: 'Damaged in transit',     hint: 'Packaging or units damaged during shipment' },
      { value: 'missing_shipment',    label: 'Missing / lost shipment', hint: 'Shipment not received, lost in transit' },
    ]
  },
  {
    value: 'documentation',
    label: 'Documentation',
    description: 'Paperwork, certificates, labelling or traceability errors',
    subtypes: [
      { value: 'missing_certificates',    label: 'Missing certificates / CoC', hint: 'Certificate of Conformance or test reports not provided' },
      { value: 'wrong_labelling',         label: 'Wrong labelling / marking',  hint: 'Incorrect serial numbers, date codes, or labels' },
      { value: 'incorrect_documentation', label: 'Incorrect documentation',    hint: 'Wrong revision docs, incorrect test results' },
      { value: 'traceability_issue',      label: 'Traceability issue',         hint: 'Cannot trace component lot, date code, or origin' },
    ]
  },
  {
    value: 'customer_escalation',
    label: 'Customer Escalation',
    description: 'Non-conformance originating from or reported by an end customer',
    subtypes: [
      { value: 'field_failure',   label: 'Field failure',    hint: 'Unit failed in the field, reported by end customer' },
      { value: 'warranty_claim',  label: 'Warranty claim',   hint: 'Customer claiming warranty replacement or repair' },
      { value: 'customer_return', label: 'Customer return',  hint: 'Unit returned by customer due to defect' },
    ]
  },
];

// Flat map of all subtype values → label for display
export const SUBTYPE_LABELS = COMPLAINT_CATEGORIES.flatMap(cat =>
  cat.subtypes.map(s => [s.value, s.label])
).reduce((acc, [k, v]) => { acc[k] = v; return acc; }, {});

// Category a subtype belongs to
export const SUBTYPE_CATEGORY = COMPLAINT_CATEGORIES.flatMap(cat =>
  cat.subtypes.map(s => [s.value, cat.value])
).reduce((acc, [k, v]) => { acc[k] = v; return acc; }, {});
